import { PipeTransform, Pipe } from '@angular/core';

@Pipe({ name: 'displayText' })
export class SelectOptionPipe implements PipeTransform {
    transform(option: any) {
        if (typeof (option) === 'object') {
            return option.value;
        }
        return option;
    }

}
